import React from "react";
import { Box, Typography } from "@mui/material";

function FormHeader() {
  return (
    <Box
      sx={{
        mb: 1,
        px: 2,
        py: 1.2,
        borderRadius: 2,
        background: "linear-gradient(90deg, #fff3e0, #ffe0b2)",
        boxShadow: 2,
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: "16px", md: "18px" },
          fontWeight: 700,
          color: "#e65100",
          textAlign: "center",
        }}
      >
        Marriage Biodata Form
      </Typography>

      <Typography
        sx={{
          fontSize: "12px",
          color: "#6d4c41",
          textAlign: "center",
          mt: 0.5,
        }}
      >
        Enter your details and customize your biodata instantly
      </Typography>
    </Box>
  );
}

export default FormHeader;
